import React, { useState } from 'react';
import { Button, Badge, Tooltip, Modal } from 'antd';
import { 
  QuestionCircleOutlined, 
  TrophyOutlined,
  PlayCircleOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { useLanguage } from '../contexts/LanguageContext';
import { useOnboardingTour } from '../hooks/useOnboardingTour';
import OnboardingTour from './OnboardingTour/OnboardingTour';

const OnboardingTrigger = () => {
  const { t } = useLanguage();
  const [showTour, setShowTour] = useState(false);

  const {
    getUserStats,
    startTour
  } = useOnboardingTour();

  const userStats = getUserStats();

  const handleStartTour = () => {
    startTour();
    setShowTour(true);
  };

  const handleTourComplete = () => {
    setShowTour(false);
  };

  const handleTourSkip = () => {
    setShowTour(false);
  };

  return (
    <>
      {/* 浮動導覽按鈕 */}
      <div 
        className="onboarding-trigger"
        style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000
        }}
      >
        <Tooltip title={t('onboarding.welcome.title')} placement="left">
          <Badge 
            count={userStats.totalAchievements} 
            size="small"
            style={{ 
              backgroundColor: '#faad14',
              color: '#fff'
            }}
          >
            <Button
              type="primary"
              shape="circle"
              size="large"
              icon={<QuestionCircleOutlined />}
              onClick={handleStartTour}
              className="onboarding-trigger-btn"
              style={{
                background: 'linear-gradient(135deg, #FD26BD 0%, #FF6FD9 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(253, 38, 189, 0.3)',
                animation: 'questionBounce 2s infinite'
              }}
            />
          </Badge>
        </Tooltip>
      </div>

      {/* 導覽模態框 */}
      <OnboardingTour
        visible={showTour}
        onComplete={handleTourComplete}
        onSkip={handleTourSkip}
      />
    </>
  );
};

export default OnboardingTrigger;
